<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Consulta de Citas</h1>
      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area" v-if="pestanaId == 0" style="background-color:#bebebc">
            <div class="row">
              <div class="col-3 font-black">
                <h5>Estatus:</h5>
              </div>
              <div class="col-3 font-black">
                <h5>Búsqueda libre:</h5>
              </div>

              <div class="col-3 font-black">
                <h5>No. de Expediente:</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <C006EstatusCita
                  v-on:valorParaElPadre="cambioEstatusCita"
                  :prefijo="enumeraciones.etiquetasDeHTML.Select"
                  :tipo="enumeraciones.tiposDeSelect.Todos"
                  :idDelInput="'catalogoEstatusCita'"
                  :parametros="parametros_EstatusCita"
                  :valorDefinido="parametros_EstatusCita.ValorDefinido"
                >
                </C006EstatusCita>
              </div>
              <div class="col-3">
                <input
                  type="text"
                  v-model="textoBusquedaLibre"
                  class="form-control campos"                    
                />
              </div>

              <div class="col-3">
                <input
                  type="text"
                  class="form-control campos"
                  placeholder="####/####"
                />
              </div>
              <div class="col-3">
                <input
                  type="button"
                  class="form-control"
                  style="background-color:var(--verde-pj-100); color: var(--blanco-pj)"
                  value="Buscar"
                  @click="buscarMisDictamenes"
                />
              </div>
            </div>
            <div class="row new-row">
              <div class="col-3 font-black">
                <h5>Periodo :</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <input
                  type="date"
                  class="form-control campos"
                  v-model="fechaInicial"
                />
              </div>
              <div class="col-3">
                <input type="date" class="form-control campos" v-model="fechaFinal" />
              </div>
            </div>

            <div class="row new-row">
              <table
                class="table table-striped table-light table-hover"
                id="tablaCitas"
              >
                <thead style="background-color:#004746;">
                  <tr>
                    <th>No. Folio Cita</th>
                    <th>No. Folio Dictamen</th>
                    <th>Nombre del Evaluado</th>
                    <th>Número de Expediente</th>
                    <th>Menor de Edad</th>
                    <th>Fecha Programada</th>
                    <th>Estatus</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-for="cita in citas" v-bind:key="cita.CitaDeDictamenId">
                    <td>{{ cita.CitaDeDictamenId }}</td>
                    <td>{{ cita.Dictamen.DictamenId }}</td>
                    <td>
                      {{ cita.PersonaEvaluada.Nombre }}
                      {{ cita.PersonaEvaluada.ApellidoPaterno }}
                      {{ cita.PersonaEvaluada.ApellidoMaterno }}
                    </td>
                    <td>{{ cita.Dictamen.Expediente.Consecutivo }}</td>
                    <td>
                      <i
                        class="fas fa-check"
                        v-if="cita.PersonaEvaluada.EsMenor"
                      ></i
                      ><i class="fas fa-times" v-else></i>
                    </td>
                    <td>{{ cita.FechaCitaString }}</td>
                    <td>{{ cita.EstatusCita.Nombre }}</td>
                    <td class="d-flex justify-content-around">
                      <i
                        class="fas fa-calendar fa-lg"
                        @click="cambiarPestana(1, cita.CitaDeDictamenId)"
                        title="Reagendar Cita"
                        v-show="cita.EstatusCita.Nombre == 'Agendada'"
                      />
                      <i
                        class="fas fa-check fa-lg"
                        @click="
                          mostrarModalFinalizarCita(cita.CitaDeDictamenId)
                        "
                        title="Concluir Cita"
                        v-show="cita.EstatusCita.Nombre == 'Agendada'"
                      />
                      <i
                        class="fas fa-info-circle fa-lg"
                        @click="irDetalleDeCita(cita.CitaDeDictamenId)"
                        title="Detalle de la Cita"
                      />
                    </td>
                  </tr>
                  <tr v-if="citas.length == 0">
                    <td colspan="6">No se encontraron citas en la búsqueda.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="areaLocalVerde" v-else-if="pestanaId == 1">
            <div class="row new-row">
              <div class="col-12">
                <CalendarioDeCitas
                  :parametros="parametros_CalendarioDeCitas"
                  v-on:valorParaElPadreCalendarioDeCitas="validarBloque"
                >
                </CalendarioDeCitas>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-10"></div>
              <div class="col-2">
                <input
                  type="button"
                  value="Cancelar"
                  class="form-control"
                  @click="cambiarPestana(0, 0)"
                />
              </div>
            </div>
          </div>
          <div
            class="modal fade"
            id="modalReagendarCita"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Reagendar Cita</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <br />
                  <div class="row">
                    <div class="col-8">
                      <h5>Fecha:</h5>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <input
                        type="date"
                        class="form-control"
                        v-model="fechaReagendamiento"
                      />
                    </div>
                  </div>
                  <div class="row new-row">
                    <div class="col-12">
                      <h5>Hora:</h5>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <input
                        type="time"
                        class="form-control"
                        v-model="horaReagendamiento"
                      />
                    </div>
                  </div>
                  <div class="row new-row">
                    <div class="col-12">
                      <h5>Duración:</h5>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <input
                        type="number"
                        min="0"
                        class="form-control"
                        v-model="duracionReagendamiento"
                      />
                    </div>
                  </div>
                  <div class="row new-row">
                    <div class="col-12">
                      <h5>Razón de Reagendamiento:</h5>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <select
                        class="form-control"
                        v-model="razonReagendamientoId"
                      >
                        <option value="-1">Seleccione una razón</option>
                        <option value="1">Inasistencia</option>
                        <option value="2">Indispnibilidad del Psicólogo</option>
                      </select>
                    </div>
                  </div>
                  <div class="row new-row">
                    <div class="col-12">
                      <h5>Sala Lúdica:</h5>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <C013SalasLudicas
                        v-on:valorParaElPadre="cambioSalaLudica"
                        :prefijo="enumeraciones.etiquetasDeHTML.Select"
                        :tipo="enumeraciones.tiposDeSelect.Ninguna"
                        :idDelInput="'catalogoSalaLudica'"
                        :parametros="parametros_SalaLudica"
                        :valorDefinido="parametros_SalaLudica.ValorDefinido"
                        :key="parametros_SalaLudica.key"
                      >
                      </C013SalasLudicas>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    data-dismiss="modal"
                    @click="reagendarCita"
                    :disabled="deshabilitarBotonReagendar"
                  >
                    Aceptar
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal fade"
            id="modalFinalizarCita"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Reagendar Cita</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <br />
                  <div class="row">
                    <div class="col-8">
                      <h5>Estatus Final de Cita:</h5>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <select class="form-control" v-model="estatusFinalCita">
                        <option value="-1">Seleccione un estatus</option>
                        <option value="2">Concluida</option>
                        <option value="3">Cancelada</option>
                      </select>
                    </div>
                  </div>
                  <div class="row new-row" v-if="estatusFinalCita == 3">
                    <div class="col-12">
                      <h5>Razón de Cancelamiento:</h5>
                    </div>
                  </div>
                  <div class="row" v-if="estatusFinalCita == 3">
                    <div class="col-12">
                      <input
                        type="text"
                        class="form-control"
                        v-model="razonCancelacion"
                      />
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    data-dismiss="modal"
                    @click="finalizarCita"
                    :disabled="deshabilitarBotonFinalizar"
                  >
                    Aceptar
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import enumeraciones from "@/../static/js/enumeraciones";
import catalogos from "@/../static/js/catalogos";
import api from "@/../static/js/api";
import comun from "@/../static/js/comun";
import axios from "axios";
import store from "@/store/index";
import CalendarioDeCitas from "@/components/SIPSIC/Dictamenes/ControlDeDictamenes/CalendarioDeCitas.vue";
export default {
  data() {
    return {
      enumeraciones,
      catalogos,
      citas: [],
      NumeroFilasPagina: 10,
      fechaReagendamiento: null,
      horaReagendamiento: null,
      usaSalaReagendamiento: false,
      duracionReagendamiento: 0,
      CitaId: 0,
      pestanaId: 0,
      parametros_CalendarioDeCitas: { FiltrarPorPsicologo: true },
      habilitarSala: true,
      parametros_EstatusCita: {
        ValorDefinido: 0,
        EstatusCitaId: 0,
        ConInactivos: false,
        tipo: { Id: -1 },
      },
      parametros_SalaLudica: {
        ValorDefinido: -2,
        SalaLudicaId: -2,
        key: 0,
        fechaCita: null,
      },
      estatusFinalCita: -1,
      razonCancelacion: "",
      textoBusquedaLibre: "",
      fechaInicial: null,
      fechaFinal: null,
      razonReagendamientoId: -1,
    };
  },
  components: {
    C006EstatusCita: catalogos.SIPSIC.C006EstatusCita,
    CalendarioDeCitas,
    C013SalasLudicas: catalogos.SIPSIC.C013SalasLudicas,
  },
  methods: {
    buscarMisDictamenes: function () {
      var peticion = {
        esPrueba: false,
        EstatusCitaDeDictamenId: this.parametros_EstatusCita.EstatusCitaId,
        TextoBusquedaLibre: this.textoBusquedaLibre,
        FechaInicial: this.fechaInicial,
        FechaFinal: this.fechaFinal,
      };
      //console.log(peticion)
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIPSIC.funciones.GetMisCitas,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            store.state.Login_AutorizacionOriginal
          )
        )
        .then((response) => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.citas = response.data.CitasDeDictamen;

            this.$nextTick(() => {
              PaginarTabla("tablaCitas", this.NumeroFilasPagina);
            });
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    mostrarModalReagendamiento: function () {
      $("#modalReagendarCita").modal("toggle");
    },
    mostrarModalFinalizarCita: function (citaId) {
      this.resetearValoresFinalizarCita();
      this.CitaId = citaId;
      $("#modalFinalizarCita").modal("toggle");
    },
    reagendarCita: function () {
      const salaLudicaId =
        this.parametros_SalaLudica.SalaLudicaId > 0
          ? this.parametros_SalaLudica.SalaLudicaId
          : null;
      var peticion = {
        CitaId: this.CitaId,
        FechaReagendamiento: this.fechaReagendamiento,
        HoraReagendamiento: this.horaReagendamiento,
        UsaSala: false,
        SalaLudicaId: salaLudicaId,
        Duracion: this.duracionReagendamiento,
        RazonReagendamientoId: this.razonReagendamientoId,
      };
      console.log(peticion);
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIPSIC.funciones.ReagendarCita,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            store.state.Login_AutorizacionOriginal
          )
        )
        .then((response) => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.buscarMisDictamenes();
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);

            this.$nextTick(() => {
              PaginarTabla("tablaCitas", this.NumeroFilasPagina);
            });
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    finalizarCita: function () {
      var peticion = {
        CitaDeDictamenId: this.CitaId,
        EsPrueba: false,
        EstatusCitaId: this.estatusFinalCita,
        MotivoCancelacion: this.razonCancelacion,
      };
      //console.log(peticion)
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIPSIC.funciones.CambiarEstatusCita,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            store.state.Login_AutorizacionOriginal
          )
        )
        .then((response) => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.buscarMisDictamenes();
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);
            this.buscarMisDictamenes();
            this.$nextTick(() => {
              PaginarTabla("tablaCitas", this.NumeroFilasPagina);
            });
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    irDetalleDeCita: function (citaId) {
      //Redirigeal usuario a la pantalla de editarusuario mandando como parametro el id de persona a editar
      this.$router.push({
        name: "DetalleDeCitaDeDictamen",
        params: { citaId: citaId },
      });
    },
    cambiarPestana: function (pestana, citaId) {
      if (pestana == 0) {
        PaginarTabla("tablaCitas", this.NumeroFilasPagina);
      } else {
        $("#navtablaCitas").remove();
      }
      this.pestanaId = pestana;
      this.CitaId = citaId;
    },
    validarBloque: function (datos) {
      if (datos.title.includes("Disponible")) {
        if (datos.title.includes("Inhábil")) {
          bootbox.dialog({
            title: "Mensaje del sistema",
            message: "¿Seguro que desea agendar en un día inhábil?",
            size: "medium",
            buttons: {
              aceptar: {
                label: "Aceptar",
                className: "btn btn-primary",
                callback: () => {
                  this.obtenerFechaHora(datos);
                },
              },
              cancelar: {
                label: "Cancelar",
                className: "btn btn-primary",
                callback: () => {},
              },
            },
          });
        } else {
          this.obtenerFechaHora(datos);
        }
      } else {
        comun.mensajeDeAlerta("Horario no válido.", null, null);
      }
    },
    obtenerFechaHora: function (datos) {
      this.fechaReagendamiento = datos.start.format("YYYY-MM-DD");
      this.horaReagendamiento = datos.start.format("HH:mm:ss");
      this.usaSala = false;
      this.habilitarSala = !datos.title.includes("(Sala Lúdica)");
      this.pestanaId = 0;
      this.parametros_SalaLudica.fechaCita =
        this.fechaReagendamiento + " " + this.horaReagendamiento;
      this.parametros_SalaLudica.key++;
      this.$forceUpdate();
      this.mostrarModalReagendamiento();
    },
    mostrarModalReagendamiento: function () {
      $("#modalReagendarCita").modal("toggle");
    },
    cambioEstatusCita(datos) {
      //Administra los cambios en el componente de Estatus De Dictamen
      catalogos;
      //console.log(datos);
      this.parametros_EstatusCita.EstatusCitaId = parseInt(
        datos[0].target.value
      );
    },
    cambioSalaLudica(datos) {
      //Administra los cambios en el componente de TipoPlantilla
      catalogos;
      //console.log(datos);
      this.parametros_SalaLudica.SalaLudicaId = parseInt(datos[0].target.value);
    },
    resetearValoresFinalizarCita: function () {
      this.estatusFinalCita = -1;
      this.razonCancelacion = "";
    },
  },
  computed: {
    deshabilitarBotonFinalizar: function () {
      return (
        this.estatusFinalCita == -1 ||
        (this.estatusFinalCita == 3 && this.razonCancelacion == "")
      );
    },
    deshabilitarBotonReagendar: function () {
      return (
        this.fechaReagendamiento == "" ||
        this.horaReagendamiento == "" ||
        this.duracionReagendamiento <= 0 ||
        this.razonReagendamientoId == -1
      );
    },
  },
  mounted: function mounted() {
    var date = new Date();
    this.fechaInicial = new Date(date.getFullYear(), date.getMonth(), 1)
      .toISOString()
      .split("T")[0];
    this.fechaFinal = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      .toISOString()
      .split("T")[0];
    this.buscarMisDictamenes();
  },
};
</script>

<style scoped>
.padding-div-low {
  padding-top: 40px;
}

.fas {
  cursor: pointer;
}

.new-row {
  margin-top: 20px;
}
.campos{
  background-color: white;
  color: black;
}
.font-black{
  color: black;
}
.areaLocalVerde{
  background-color: var(--verde-pj-100);
  box-shadow: 0px 6px 20px 4px #161616;
  padding: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/SIPSIC/Dictamenes/ConsultaDeCitas/ConsultaDeCitas.vue